<template>
  <div>
    <van-dialog v-model="show" title="咨询" show-cancel-button @confirm="onSubmit">
      <van-field
        v-model="username"
        required
        name="姓名"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="phone"
        required
        type="tel"
        name="phone"
        label="手机号"
        placeholder="手机号"
        :rules="[
            { required: true, message: '请填写手机号' },
            { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' },
          ]"
      />
      <van-field
        v-model="message"
        rows="4"
        autosize
        required
        label="留言"
        type="textarea"
        placeholder="请输入留言"
      />
      <van-field name="fileList" label="咨询图片">
        <template #input>
          <van-uploader
            :max-count="1"
            v-model="fileList"
            :deletable="true"
            :max-size="1000 * 1024"
            @oversize="onOversize"
            :after-read="checkUpload"
          />
          <!-- <van-uploader v-model="fileList" :before-delete='deleteList'  :after-read='checkUpload' /> -->
        </template>
      </van-field>
    </van-dialog>
  </div>
</template>
<script>
import URL from '@/api/api'
import { Toast } from 'vant'
export default {
  props: ['id'],
  data() {
    return {
      username: "",
      phone: "",
      message: "",
      show: false,
      fileList: [],
      imgId: '',
      mgurl: '',
      userId: ''
    };
  },
  methods: {
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10MB');
    },
    checkUpload(file) {
      let data = new FormData();
      //file是当前file对象, 此对象包含file和content
      data.append("file", file.file);
      data.append("bucketName", "messageimg")
      this.$fetchPost(URL.uploadmessageImg.url, data).then((res) => {
        this.imgId = res.data.data.id;
        this.imgurl = res.data.data.fileUrl
      });
    },
    isWenXin: function () {
      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
        return true; // 是微信端
      } else {
        return false;
      }

    },
    onSubmit() {
      let data = {
        productId: this.id,
        name: this.username,
        phone: this.phone,
        message: this.message,
        userId: localStorage.getItem("userid"),
        fielid: this.imgId == '' ? null : this.imgId,
        imgurl: this.imgurl,
      }
      if(this.username==''){
        Toast('请输入姓名')
        return
      }
      if(this.phone==''){
        Toast('请输入手机号')
        return
      }
      if(this.message==''){
        Toast('请输入留言')
        return
      }

      this.$fetchPost(URL.postConsult.url, data).then(res => {
        Toast(res.data.msg);
      });
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
      let d = new FormData();
      d.append("name", this.username)
      d.append("openid", localStorage.getItem("openid"))
      d.append("scene", this.isWenXin() ? 1 : 2)
      d.append("datetime", yy + '/' + mm + '/' + dd + ' ' + hh + ':' + mf + ':' + ss)
      d.append("message", '感谢你的咨询，我们将尽快联系你')
      //  let d={
      //     name:this.username,
      //     openid:localStorage.getItem("openid"),
      //     scene:this.isWenXin()?1:2,
      //     // openid:"o59kX619xOOzJ2Bwd4YqlY5gjO50",
      //     datetime:yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss,
      //     message:'感谢你的咨询，我们将尽快联系你'
      //   }
      this.$fetchPost(URL.noticemessage.url, d).then(res => {
        Toast(res.data.msg);
      })

    },
  },
};
</script>